import { z } from "zod/v4";
import {
  CameraSubject,
  ClientApiFeaturePathParams,
  CollectionResponse,
  defineResource,
  defineEndpoint,
} from "@visioni/a3s-client-api";
import { FEATURE_NAME } from "../constants";

export type ListSnapshotsPathParams = ClientApiFeaturePathParams;

export const SignedSnapshot = z.object({
  url: z.string(),
  headers: z.object({
    "X-Media-Signature": z.string(),
    "X-Media-Expires": z.string(),
  }),
});

export type SignedSnapshot = z.output<typeof SignedSnapshot>;

export const SnapshotItem = z.object({
  subject: CameraSubject,
  snapshot: SignedSnapshot,
});

export type SnapshotItem = z.output<typeof SnapshotItem>;

export const ListSnapshotsResponse = CollectionResponse(SnapshotItem);

export type ListSnapshotsResponse = z.output<typeof ListSnapshotsResponse>;

// ==================== Resources & Endpoints ====================

export const snapshotsResource = defineResource({
  feature: FEATURE_NAME,
  resource: "snapshots",
});

export const listSnapshotsEndpoint = defineEndpoint(snapshotsResource, {
  responseSchema: ListSnapshotsResponse,
});

// TODO: clean this up
// Just an example of a resource with path parameters
export const snapshotResource = defineResource({
  feature: FEATURE_NAME,
  resource: "snapshots/{snapshotId}",
  resourcePathSchema: z.object({ snapshotId: z.string() }), // compiler error if snapshotId is not defined
});

// TODO: clean this up
// Just an example of an endpoint with body schema
export const putSnapshotEndpoint = defineEndpoint(snapshotResource, {
  method: "PUT",
  responseSchema: ListSnapshotsResponse,
  bodySchema: ListSnapshotsResponse, // compiler error if bodySchema is not defined
});
